import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import i18n from "i18next";
import { EntProcessingCompanies } from "../../../../models/organic/processingCompanies";
import { EntProcessingCompaniesFilter } from "../../../../models/filters/organic/processingCompany";
import { useLazyGetProcessingCompaniesListQuery } from "../../../../redux/api/organic/ProcessingCompanies";
import { EmptyData } from "../../../../components/empty/emptyData";
import { PageHeader } from "../../../../components/page-header";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { FilterCompanies } from "./FilterCompanies";
import { AddProcCompanies } from "./AddProcCompanies";
import { useCompanies } from "./useCompanies";
import _ from "lodash";

enum FormField {
  companyName,
  legalFormId,
  industryTypeId,
  regionId,
  areaId,
  territorialUnitId,
  address,
  registrationDate,
  statusId,
  productTypeId
}

export const ProcessingCompanies = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedItem, setSelectedItem] = useState<EntProcessingCompanies>(new EntProcessingCompanies());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showReportModal, setShowReportModal] = useState<boolean>(false);
  const [form] = useForm();
  const { t } = useTranslation()

  const [getArchiveFolders] = useLazyGetProcessingCompaniesListQuery();
  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntProcessingCompanies, EntProcessingCompaniesFilter>({
	initialFilter: new EntProcessingCompaniesFilter(),
	query: getArchiveFolders
  });

  const {
    onAddProcessingCompanies,
    onDeleteProcessingCompanies,
    onEditProcessingCompanies
  } = useCompanies(modal, () => {
	searchHandleClick();
  })
  const [height, setHeight] = useState<number>(0);

  const storedData = JSON.parse(localStorage.getItem("availableRoutes") || "[]");
  const isReportAvailable = storedData.some((route: any) => (route.alias === "/report" || route.alias === "/interactive-map-ws") && route.methodPost);

  const openAddModal = (item: EntProcessingCompanies) => {
	setSelectedItem(item);
	setShowModal(true);
  }

  const setEntityFromFields = (): EntProcessingCompaniesFilter => {
	let filt: EntProcessingCompaniesFilter = _.clone(filter);

	filt.companyName = form.getFieldValue(FormField.companyName) ?? null;
	filt.legalFormId = form.getFieldValue(FormField.legalFormId) ?? null;
	filt.industryTypeId = form.getFieldValue(FormField.industryTypeId) ?? null;
	filt.regionId = form.getFieldValue(FormField.regionId) ?? null;
	filt.areaId = form.getFieldValue(FormField.areaId ?? null);
	filt.territorialUnitId = form.getFieldValue(FormField.territorialUnitId) ?? null;
	filt.address = form.getFieldValue(FormField.address) ?? null;
	filt.registrationDate = form.getFieldValue(FormField.registrationDate) ?? null;
	filt.statusId = form.getFieldValue(FormField.statusId) ?? null;
	filt.productType = form.getFieldValue(FormField.productTypeId) ?? null;
	filt.page = 1;
	return filt;
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.companyName, value: null },
	  { name: FormField.legalFormId, value: null },
	  { name: FormField.industryTypeId, value: null },
	  { name: FormField.regionId, value: null },
	  { name: FormField.areaId, value: null },
	  { name: FormField.territorialUnitId, value: null },
	  { name: FormField.address, value: null },
	  { name: FormField.registrationDate, value: null },
	  { name: FormField.statusId, value: null },
	  { name: FormField.productTypeId, value: null },
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('Название компании') }</th>
		  <th>{ t('Юридическая форма') }</th>
		  <th>{ t('Адрес') }</th>
		  <th>{ t('Дата регистрации') }</th>
		  <th>{ t('Ежедневная мощность') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ? (
		  <tr>
			<th colSpan={ 7 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		) : null }
		{ data.length !== 0 ? data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item.companyName }</td>
			<td>{ i18n.language === 'ru' ? item.legalForm?.nameRu : item.legalForm?.nameKy }</td>
			<td>{ item.address }</td>
			<td>{ item.registrationDate }</td>
			<td>{ item.processingCapacities?.[0]?.dailyCapacity ? `${item.processingCapacities[0].dailyCapacity.toLocaleString()} ${item.processingCapacities[0].unitMeasurement?.nameRu || ''}` : '-' }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteProcessingCompanies(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) : (
		  <tr>
			<td colSpan={ 7 }>
			  <EmptyData/>
			</td>
		  </tr>
		) }
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('Перерабатывающие компании') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('general.records_found') } { totalItems }
		  </Typography.Text>
		}
	  />
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntProcessingCompanies())
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterCompanies
		  onSearch={ searchHandleClick }
		  onReset={ () => {
			clearFields();
			searchHandleClick()
		  } }
		  formField={ FormField }
		  form={ form }
		/> }
		setHeight={ setHeight }
		table={ table }
	  />

	  <AddProcCompanies
		item={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedItem.id !== null ? onEditProcessingCompanies : onAddProcessingCompanies }
	  />
	  { contextHolder }
	</>
  );
}
